import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { autoRegisterCurrentPage } from '../lib/searchRegistry';

/**
 * Hook to automatically index visible page content for search.
 * It collects text from all elements with data-read-section attribute
 * and registers it with the global search registry.
 *
 * @param {{ mr?: string[], en?: string[] }} extraTerms
 *        Optional additional keywords for Marathi (mr) and English (en).
 */
const usePageSearchIndex = (extraTerms = { mr: [], en: [] }) => {
  const location = useLocation();
  const { isMarathi } = useLanguage();

  useEffect(() => {
    // Register/update page content - don't unregister on unmount to keep content searchable
    // This ensures content from all visited pages remains searchable
    autoRegisterCurrentPage(location.pathname, { isMarathi, extraTerms });
    // Note: We intentionally don't unregister on unmount so content persists across navigation
  }, [location.pathname, isMarathi, extraTerms]);
};

export default usePageSearchIndex;


